import type { HttpClient } from '~/shared/api'
import type { LoggerFactory } from '~/shared/interfaces'
import { ResumesMainService } from '~/services/resumes/ResumesMainService'
import { ResumesFiltersService } from '~/services/resumes/ResumesFiltersService'

export class ResumesService {
  readonly main: ResumesMainService
  readonly filters: ResumesFiltersService

  constructor(http: HttpClient, createLogger: LoggerFactory) {
    this.main = new ResumesMainService(http, createLogger('ResumesMainService'))
    this.filters = new ResumesFiltersService(http)
  }
}
